/* Premier Catering Supplies — homepage product finder (pch-finder section), 26-9-2026.
   Choosing a product loads that collection's real spec data (assets/pcl-facet-data.js) and every other box
   lists ONLY values that still have products, with their counts — so no choice can ever end in "no matches".
   "Show N products" opens the collection with the same filters applied (collection page reads the hash). */
(function () {
  'use strict';
  var form = document.querySelector('[data-pch-finder]');
  if (!form || !window.PCLData) return;
  var D = window.PCLData;
  var cfg = {};
  try { cfg = JSON.parse(form.parentNode.parentNode.querySelector('[data-pch-finder-config]').textContent); } catch (e) { return; }
  var sel = {
    product: form.querySelector('[data-f="product"]'),
    size: form.querySelector('[data-f="size"]'),
    colour: form.querySelector('[data-f="colour"]'),
    material: form.querySelector('[data-f="material"]')
  };
  var btn = form.querySelector('[data-f-btn]');
  var status = form.querySelector('[data-f-status]');
  var btnLabel = btn.textContent;
  var allUrl = form.getAttribute('data-all');
  var data = null, sizeKey = 'dia', token = 0;
  var ANY = { size: 'Any size', colour: 'Any colour', material: 'Any material' };
  var FACET = { colour: 'col', material: 'mat' };

  function product() { var i = sel.product.value; return i === '' ? null : cfg.products[+i]; }
  function facetOf(k) { return k === 'size' ? sizeKey : FACET[k]; }
  function state(skip) {
    var st = {};
    ['size', 'colour', 'material'].forEach(function (k) { if (k !== skip && sel[k].value) st[facetOf(k)] = [sel[k].value]; });
    return st;
  }
  function valuesFor(k) {
    var f = facetOf(k);
    var def = D.defs().filter(function (d) { return d.key === f; })[0];
    return def ? def.values : [];
  }
  function fill(k) {
    var s = sel[k], keep = s.value;
    var cnt = D.counts(data.items, state(k), facetOf(k));
    var opts = valuesFor(k).filter(function (v) { return cnt[v.k]; });
    s.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = ANY[k]; s.appendChild(o);
    opts.forEach(function (v) {
      var op = document.createElement('option');
      op.value = v.k; op.textContent = v.label + ' (' + cnt[v.k].toLocaleString('en-GB') + ')';
      s.appendChild(op);
    });
    s.value = opts.some(function (v) { return v.k === keep; }) ? keep : '';
    s.disabled = !opts.length;
  }
  function matches() { var st = state(); return data.items.filter(function (it) { return D.match(it, st); }).length; }
  function mark() { Object.keys(sel).forEach(function (k) { sel[k].classList.toggle('has-value', sel[k].value !== ''); }); }
  function setBtn(n) {
    btn.disabled = false;
    btn.textContent = n === null ? btnLabel : 'Show ' + n.toLocaleString('en-GB') + ' product' + (n === 1 ? '' : 's');
  }
  function lock(text) {
    ['size', 'colour', 'material'].forEach(function (k) {
      sel[k].innerHTML = '<option value="">' + (text || ANY[k]) + '</option>';
      sel[k].disabled = true;
    });
  }
  function refresh() {
    ['size', 'colour', 'material'].forEach(fill);
    /* a second pass settles any box whose list depended on a value that was just cleared */
    ['size', 'colour', 'material'].forEach(fill);
    mark();
    setBtn(matches());
    status.textContent = '';
  }
  function onProduct() {
    var p = product();
    data = null;
    mark();
    if (!p) { lock(); setBtn(null); status.textContent = ''; return; }
    var my = ++token;
    lock('Loading…');
    btn.disabled = true;
    btn.classList.add('is-busy');
    status.textContent = '';
    D.load(p.url).then(function (d) {
      if (my !== token) return;
      data = d;
      var withDia = d.items.filter(function (it) { return it.f.dia; }).length;
      var withCap = d.items.filter(function (it) { return it.f.cap; }).length;
      sizeKey = withDia >= withCap ? 'dia' : 'cap';
      btn.classList.remove('is-busy');
      ['size', 'colour', 'material'].forEach(function (k) { sel[k].value = ''; });
      refresh();
    }).catch(function () {
      if (my !== token) return;
      btn.classList.remove('is-busy');
      lock();
      setBtn(p.count);
      status.textContent = 'Size, colour and material could not load — “Show products” opens the whole range.';
    });
  }

  sel.product.addEventListener('change', onProduct);
  ['size', 'colour', 'material'].forEach(function (k) { sel[k].addEventListener('change', function () { if (data) refresh(); }); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var p = product();
    if (!p) { window.location.href = allUrl; return; }
    window.location.href = p.url + (data ? D.toHash(state()) : '');
  });
  lock();
  if (sel.product.value) onProduct();
})();